/**
 * BalanceService — DISABLED (SSE stream was causing CORS errors).
 * Balance updates now happen via regular API calls in Header.jsx.
 * This stub prevents import errors from other files.
 */

class BalanceService {
  constructor() {
    this.isConnected = false;
    this.listeners = new Map();
  }

  startListening() {
    // Disabled — no SSE stream
  }

  stopListening() {
    // No-op
  }

  on(event, callback) {
    if (!this.listeners.has(event)) this.listeners.set(event, []);
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    const cbs = this.listeners.get(event);
    if (cbs) this.listeners.set(event, cbs.filter(cb => cb !== callback));
  }

  getStatus() {
    return { isConnected: false, disabled: true };
  }
}

// Singleton
if (!window.balanceService) {
  window.balanceService = new BalanceService();
}

export default window.balanceService;
